import { atom, selectorFamily } from "recoil";

import type { ActivityEmailEventType } from "Types/beRecipientsApi";

import type {
  PanelEditRecipientState,
  RecipientActivityStreamFiltersState,
  RecipientGroupsState,
  RecipientTrackingChangeLogsState,
} from "Pages/RecipientsList/model";

import { activityFiltersToEventTypes } from "Pages/RecipientsList/recoil/services/recipient";

export const panelEditRecipientState = atom<PanelEditRecipientState>({
  key: "recipientsList_panelEditRecipientState",
  default: {
    show: false,
    title: undefined,
    recipient: undefined,
    score: undefined,
    tracking: undefined,
    trackingInsertDate: undefined,
    idNLFrom: undefined,
  },
});

export const recipientGroupsState = atom<RecipientGroupsState>({
  key: "recipientsList_recipientGroupsState",
  default: {
    loading: false,
    status: "initial",
    items: [],
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    orderBy: "AssignmentDate",
    orderDescending: true,
  },
});

export const recipientAllGroupsState = atom<number[]>({
  key: "recipientsList_recipientAllGroupsState",
  default: [],
});

export const recipientTrackingChangeLogsState =
  atom<RecipientTrackingChangeLogsState>({
    key: "recipientsList_recipientTrackingChangeLogsState",
    default: {
      loading: false,
      status: "initial",
      items: [],
      totalItems: 0,
      pageNumber: 1,
      pageSize: 5,
      orderBy: "InsertDate",
      orderDescending: true,
    },
  });

export const recipientActivityStreamFiltersState =
  atom<RecipientActivityStreamFiltersState>({
    key: "recipientsList_recipientActivityStreamFiltersState",
    default: {
      allFilters: true,
      filters: [],
    },
  });

export const recipientActivityStreamActivityTypesState = selectorFamily<
  ActivityEmailEventType[],
  "email" | "sms"
>({
  key: "recipientsList_recipientActivityStreamActivityTypesState",
  get:
    (channel: "email" | "sms") =>
    ({ get }) => {
      const { filters, allFilters } = get(recipientActivityStreamFiltersState);

      return activityFiltersToEventTypes(allFilters, filters, channel);
    },
});
